var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7733 17.3469L17.9865 15.6494V15.6129C17.9865 15.5947 17.9865 15.5582 18.0047 15.5399C18.3497 13.3496 16.8789 11.2871 14.7 10.9038V10.8673C14.2098 10.776 13.7195 10.7942 13.2656 10.8855L11.6133 1.10213C13.1567 0.828345 14.7727 0.810093 16.4068 1.10213C23.9785 2.41632 29.0625 9.62608 27.8097 17.2374C27.8097 17.2556 27.8097 17.2739 27.8097 17.2922L27.7733 17.3469Z",
    fill: "#E79E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.353 1.08392L14.6644 10.922H14.6281C14.6099 10.922 14.5736 10.922 14.5555 10.9038C12.3766 10.557 10.3248 12.0355 9.96164 14.2258H9.92533C9.83454 14.7186 9.8527 15.2114 9.94349 15.6677L0.211134 17.3287C-0.0612262 15.7772 -0.0793836 14.1528 0.211134 12.5283C1.51846 4.91696 8.69063 -0.193761 16.2623 1.06567C16.2804 1.06567 16.2986 1.06567 16.3167 1.06567L16.353 1.08392Z",
    fill: "#E79E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8352 16.3614C22.8352 16.3432 22.8352 16.3431 22.8352 16.3249C23.6341 11.415 20.3476 6.77881 15.4633 5.93919H15.427C15.4088 5.93919 15.4089 5.93919 15.3907 5.93919C15.2818 5.92094 15.1728 5.90269 15.0639 5.90269C14.9368 5.88443 14.8097 5.86618 14.6826 5.86618H14.6644C10.0524 5.48288 5.83992 8.69533 5.05915 13.368C4.87757 14.4266 4.89573 15.467 5.05915 16.4709L11.3234 15.3758C11.269 15.0837 11.2508 14.7552 11.3053 14.4449H11.3234C11.5595 13.0394 12.885 12.0903 14.2831 12.2911C14.3012 12.2911 14.3194 12.2911 14.3376 12.2911H14.3557V12.2546V12.2728C15.7538 12.5101 16.698 13.8425 16.4983 15.248C16.4983 15.2662 16.4983 15.2845 16.4983 15.3028V15.321L22.8171 16.3979L22.8352 16.3614Z",
    fill: "#FECE26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.193359 17.2921L13.9385 14.8645L27.7744 17.2921V17.8214H0.193359V17.2921Z",
    fill: "#3F51B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7562 17.2922H0.193359V21.1253H27.7562V17.2922Z",
    fill: "#536DFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany07);
export default __webpack_public_path__ + "static/media/company-07.6df96540bfc4529e54c1a5da187ab7f2.svg";
export { ForwardRef as ReactComponent };